import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export function LimitExceededMessage() {
    const modalTitle = <Typography>Limit für Inhalte erreicht.</Typography>;
    const modalContent = (
        <ContentTypography>
            Der Inhalt wurde nicht erstellt, weil das Limit überschritten wurde.
            Bitte versuche es in Kürze erneut.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
